// =========================
// COMPONENTS
// =========================

import "./components/customer/RegistrationB2B";


$(function()
{
    $("body").on("click", ".btn[data-toggle='modal'][href='#login']", function()
    {
        window.ceresStore.dispatch("loadComponent", "login-modal");
    });
});

